var render, staticRenderFns
import script from "./SelectPaymentMethod.vue?vue&type=script&lang=js"
export * from "./SelectPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./SelectPaymentMethod.vue?vue&type=style&index=0&id=12ec28d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports